import { render, staticRenderFns } from "./iFrameSignin.vue?vue&type=template&id=b03c665a&scoped=true"
import script from "./iFrameSignin.vue?vue&type=script&lang=js"
export * from "./iFrameSignin.vue?vue&type=script&lang=js"
import style0 from "./iFrameSignin.vue?vue&type=style&index=0&id=b03c665a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03c665a",
  null
  
)

export default component.exports